import { PinMode } from "@models/index.model";

export enum ViewPortType {
  PAGE_WIDTH = 'page-width',
  PAGE_FIT = 'page-fit',
  PAGE_HEIGHT = 'page-height',
}

export enum ZoomAction {
  IN = 'in',
  OUT = 'out',
  UPDATE = 'update'
}

export enum RenderTextMode {
  DISABLED,
  ENABLED,
  ENHANCED,
}

export enum SignAreaStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum ButtonStatus {
  ENABLED,
  DISABLED,
}

export enum SignImageType {
  DEFAULT = 'DEFAULT',
  IMG_PROFILE = 'IMG_PROFILE',
}

export enum SignImagePagesType {
  CURRENT = 'CURRENT',
  LAST = 'LAST',
  ALL = 'ALL',
  RANGE = 'RANGE',
}

export enum SignClickEvent {
  SIGN_IMG = 0,
  SIGN_NO_IMG = 1,
}

export interface SignUserConfig {
  certificateIdToSign: string;
  currentPage: number;
  lastPage: number;
  pagesToSign: number[];
  imageBase64ToSign: string;
  signZone: BoundingClientRect;
}
export interface BoundingClientRect {
  height: number;
  width: number;
  x: number;
  y: number;
}
export interface SignAreaConfiguration {
  x: number;
  y: number;
  width: number;
  height: number;
  imageBase64: string;
  pages: number[];
}

export interface DocumentConfiguration {
  rect: DOMRect;
  scale: number;
  previousScale?: number;
}

export interface ScaleRegistry {
  scale: number;
  previousScale?: number;
}

export interface PageInfo {
  currentPage: number;
  pagesRange?: number[];
  totalPages: number;
}

export interface SigntrustCertificate {
  alias: string;
  certificateHandler: number;
  expiration: Date;
  issuer: string;
  subject: string;
  thumbprint: string;
  needPin: boolean;
  needReason: boolean;
  pinMode: PinMode;
  type: number;
}

export interface SignDocumentRequest {
  certificateId: number;
  visualSignature?: SignAreaConfiguration;
  pin?: string;
  reason?: string;
}

export interface SignCheckPinRequest {
  selectedCertId: number;
  pin: string;
}

export class EventData {
  name: string;
  value: any;

  constructor(name: string, value: any) {
    this.name = name;
    this.value = value;
  }
}

export interface ImageSelectionEvent {
  signType: SignClickEvent;
  signImg?: string;
  signPages?: PageInfo;
}
